/* SVT Story Viewer - an IG-style player for a product's lifestyle media.
   Data: #svt-story-data (the custom.story_media metafield).
   Stills hold for 5s, matching what people already expect from Instagram. */
(function () {
  'use strict';
  var IMAGE_MS = 5000;

  function init() {
    var ring = document.getElementById('svt-story-ring');
    var overlay = document.getElementById('svt-story-overlay');
    var dataEl = document.getElementById('svt-story-data');
    if (!ring || !overlay || !dataEl || ring.dataset.svtInit) return;
    ring.dataset.svtInit = '1';

    // Move the overlay to <body>: the gallery's own img/video width rules would otherwise
    // reshape it, and an ancestor transform would break position: fixed.
    if (overlay.parentElement !== document.body) document.body.appendChild(overlay);

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var items = (data && data.items) || [];
    if (!items.length) return;

    var pid = ring.dataset.productId || '';
    var seenKey = 'svt_story_seen_' + pid;
    var sig = items.length + ':' + items[0].src;

    function isSeen() {
      try { return localStorage.getItem(seenKey) === sig; } catch (e) { return false; }
    }
    function markSeen() {
      try { localStorage.setItem(seenKey, sig); } catch (e) {}
      ring.classList.add('svt-story-ring--seen');
    }
    if (isSeen()) ring.classList.add('svt-story-ring--seen');

    var stage = overlay.querySelector('.svt-story-stage');
    var progressWrap = overlay.querySelector('.svt-story-progress');
    var btnClose = overlay.querySelector('[data-svt-close]');
    var btnMute = overlay.querySelector('[data-svt-mute]');
    var iconSoundOn = overlay.querySelector('[data-svt-sound-on]');
    var iconSoundOff = overlay.querySelector('[data-svt-sound-off]');
    var tapPrev = overlay.querySelector('.svt-story-tap--prev');
    var tapNext = overlay.querySelector('.svt-story-tap--next');

    var idx = 0, bars = [], curVideo = null, imgTimer = null, imgStart = 0, imgElapsed = 0;
    var muted = false, wakeLock = null, open = false, holdTimer = null, held = false, rafId = null;

    // Build one progress bar per item.
    progressWrap.innerHTML = '';
    items.forEach(function () {
      var s = document.createElement('span');
      s.appendChild(document.createElement('i'));
      progressWrap.appendChild(s);
    });
    bars = [].map.call(progressWrap.querySelectorAll('i'), function (i) { return i; });

    function setBar(i, pct) { if (bars[i]) bars[i].style.width = (pct * 100) + '%'; }

    function requestWake() {
      if (navigator.wakeLock && navigator.wakeLock.request) {
        navigator.wakeLock.request('screen').then(function (wl) { wakeLock = wl; }).catch(function () {});
      }
    }
    function releaseWake() {
      if (wakeLock) { wakeLock.release().catch(function () {}); wakeLock = null; }
    }

    function clearStage() {
      if (curVideo) {
        curVideo.pause();
        curVideo.removeAttribute('src');
        try { curVideo.load(); } catch (e) {}
        curVideo = null;
      }
      if (imgTimer) { clearTimeout(imgTimer); imgTimer = null; }
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      stage.innerHTML = '';
    }

    function showUnmuteHint() {
      if (overlay.querySelector('.svt-story-btn--unmute')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'svt-story-btn svt-story-btn--unmute';
      b.textContent = '🔊 ' + (overlay.getAttribute('data-unmute-label') || 'Tap for sound');
      b.addEventListener('click', function (ev) {
        ev.stopPropagation();
        muted = false;
        if (curVideo) { curVideo.muted = false; }
        updateMuteIcon();
        b.remove();
      });
      overlay.querySelector('.svt-story-frame').appendChild(b);
    }

    function updateMuteIcon() {
      if (iconSoundOn) iconSoundOn.style.display = muted ? 'none' : '';
      if (iconSoundOff) iconSoundOff.style.display = muted ? '' : 'none';
    }

    function playIndex(i) {
      clearStage();
      idx = i;
      for (var k = 0; k < items.length; k++) setBar(k, k < i ? 1 : 0);
      var item = items[i];

      var spin = document.createElement('div');
      spin.className = 'svt-story-spinner';
      stage.appendChild(spin);

      if (item.type === 'image') {
        var img = document.createElement('img');
        img.src = item.src;
        img.alt = '';
        img.onload = function () { spin.remove(); };
        stage.appendChild(img);
        imgStart = performance.now();
        imgElapsed = 0;
        function tick(now) {
          if (!open) return;
          var el = imgElapsed + (now - imgStart);
          setBar(i, Math.min(el / IMAGE_MS, 1));
          if (el >= IMAGE_MS) { next(); return; }
          rafId = requestAnimationFrame(tick);
        }
        rafId = requestAnimationFrame(tick);
      } else {
        var v = document.createElement('video');
        v.setAttribute('playsinline', '');
        v.playsInline = true;
        v.preload = 'auto';
        v.src = item.src;
        v.muted = muted;
        curVideo = v;
        v.addEventListener('canplay', function () { spin.remove(); });
        v.addEventListener('timeupdate', function () {
          if (v.duration) setBar(i, v.currentTime / v.duration);
        });
        v.addEventListener('ended', function () { setBar(i, 1); next(); });
        stage.appendChild(v);
        var p = v.play();
        if (p && p.catch) {
          p.catch(function () {
            v.muted = true;
            muted = true;
            updateMuteIcon();
            v.play().catch(function () {});
            showUnmuteHint();
          });
        }
      }
      // Warm the next video so the cut between items is seamless.
      if (items[i + 1] && items[i + 1].type !== 'image') {
        var pre = document.createElement('link');
        pre.rel = 'prefetch';
        pre.href = items[i + 1].src;
        if (!document.querySelector('link[href="' + items[i + 1].src + '"]')) document.head.appendChild(pre);
      }
    }

    function next() {
      if (idx + 1 >= items.length) { markSeen(); close(); return; }
      playIndex(idx + 1);
    }
    function prev() {
      if (idx === 0) { playIndex(0); return; }
      playIndex(idx - 1);
    }

    function pauseCurrent() {
      if (curVideo) curVideo.pause();
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; imgElapsed += performance.now() - imgStart; }
    }
    function resumeCurrent() {
      if (!open) return;
      if (curVideo) curVideo.play().catch(function () {});
      else if (stage.querySelector('img')) {
        imgStart = performance.now();
        (function tick(now) {
          if (!open) return;
          var el = imgElapsed + (performance.now() - imgStart);
          setBar(idx, Math.min(el / IMAGE_MS, 1));
          if (el >= IMAGE_MS) { next(); return; }
          rafId = requestAnimationFrame(tick);
        })();
      }
    }

    function openViewer() {
      open = true;
      muted = false;
      updateMuteIcon();
      overlay.hidden = false;
      document.documentElement.classList.add('svt-story-lock');
      requestWake();
      playIndex(0);
    }

    function close() {
      open = false;
      clearStage();
      overlay.hidden = true;
      document.documentElement.classList.remove('svt-story-lock');
      releaseWake();
      var hint = overlay.querySelector('.svt-story-btn--unmute');
      if (hint) hint.remove();
    }

    // -- interactions --
    ring.addEventListener('click', openViewer);
    btnClose.addEventListener('click', function (e) { e.stopPropagation(); close(); });
    if (btnMute) btnMute.addEventListener('click', function (e) {
      e.stopPropagation();
      muted = !muted;
      if (curVideo) curVideo.muted = muted;
      updateMuteIcon();
    });

    function bindTap(el, fn) {
      el.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        held = false;
        holdTimer = setTimeout(function () { held = true; pauseCurrent(); }, 220);
      });
      el.addEventListener('pointerup', function (e) {
        e.preventDefault();
        clearTimeout(holdTimer);
        if (held) { resumeCurrent(); held = false; } else { fn(); }
      });
      el.addEventListener('pointercancel', function () {
        clearTimeout(holdTimer);
        if (held) { resumeCurrent(); held = false; }
      });
    }
    bindTap(tapNext, next);
    bindTap(tapPrev, prev);

    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
    });

    document.addEventListener('visibilitychange', function () {
      if (!open) return;
      if (document.hidden) { pauseCurrent(); releaseWake(); }
      else { resumeCurrent(); requestWake(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
